<template>
  <div class="">
      <div class="headertop u-flex u-flex-items-center u-flex-between"  v-if="homeNowMatchLineUp.firstPlayerList && homeNowMatchLineUp.firstPlayerList.length > 0 && homeNowMatchLineUp.subPlayerList.length > 0  && homeNowMatchLineUp.injuryPlayerList.length > 0 ">
        <div class="homeName u-flex u-flex-center u-flex-items-center">
          <img :src="info.homeTeam.customLogo?info.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt="">
         {{info.homeTeam.nameCn}}
        </div>
        <div class="battle_box">
          <div class="lines">
            <span class="qiu"></span>
          </div>
          <div class="qiuImg">
            <img src="/static/scope/state/1.png" alt="" srcset="">
          </div>
          <div class="lines">
            <span class="qius"></span>
          </div>
        </div>
        <div class="homeName u-flex u-flex-center u-flex-items-center">
          <img :src="info.awayTeam.customLogo?info.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt="">
          {{info.awayTeam.nameCn}}
        </div>
      </div>
      <div v-if="homeNowMatchLineUp.firstPlayerList && homeNowMatchLineUp.firstPlayerList.length > 0 && homeNowMatchLineUp.subPlayerList.length > 0  && homeNowMatchLineUp.injuryPlayerList.length > 0 ">
        <div class="firstPk" v-if="homeNowMatchLineUp.firstPlayerList && homeNowMatchLineUp.firstPlayerList.length > 0">
          <div class="firstPkName">
            首发阵容
          </div>
          <div class="pkGroup" >
            <div class="leftpklist">
              <div class="leftpkItem"  v-for="(item,index) in homeNowMatchLineUp.firstPlayerList">
                <div class="numberId">
                  {{item.number}}
                </div>
                <div class="userHeadr">
                  <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="leftpkname">
                  <span>{{item.nameCn}}</span>
                  <span>{{item.position}}</span>
                </div>
              </div>
            </div>
            <div class="leftpklist"  style="border-right: 0;">
              <div class="rightpkItem"  v-for="(item,index) in awayNowMatchLineUp.firstPlayerList" :key="index">
                <div class="leftpkname">
                   <span>{{item.nameCn}}</span>
                   <span>{{item.position}}</span>
                </div>
                <div class="userHeadr">
                  <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="numberId">
                  {{item.number}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="firstPk" v-if="homeNowMatchLineUp.subPlayerList && homeNowMatchLineUp.subPlayerList.length > 0">
          <div class="firstPkName">
            替补阵容
          </div>
          <div class="pkGroup" >
            <div class="leftpklist">
              <div class="leftpkItem"  v-for="(item,index) in homeNowMatchLineUp.subPlayerList">
                <div class="numberId">
                  {{item.number}}
                </div>
                <div class="userHeadr">
                  <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="leftpkname">
                  <span>{{item.nameCn}}</span>
                  <span>{{item.position}}</span>
                </div>
              </div>
            </div>
            <div class="leftpklist"  style="border-right: 0;">
              <div class="rightpkItem"  v-for="(item,index) in awayNowMatchLineUp.subPlayerList" :key="index">
                <div class="leftpkname">
                   <span>{{item.nameCn}}</span>
                   <span>{{item.position}}</span>
                </div>
                <div class="userHeadr">
                  <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="numberId">
                  {{item.number}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="firstPk" v-if="homeNowMatchLineUp.injuryPlayerList && homeNowMatchLineUp.injuryPlayerList.length > 0">
          <div class="firstPkName">
            伤停状态
          </div>
          <div class="pkGroup" >
            <div class="leftpklist">
              <div class="leftpkItem"  v-for="(item,index) in homeNowMatchLineUp.injuryPlayerList">
                <div class="numberId">
                  {{item.number}}
                </div>
                <div class="userHeadr">
                   <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="leftpkname">
                  <span>{{item.nameCn}}</span>
                  <span>{{item.position}}</span>
                </div>
              </div>
            </div>
            <div class="leftpklist" style="border-right: 0;">
              <div class="rightpkItem"  v-for="(item,index) in awayNowMatchLineUp.injuryPlayerList" :key="index">
                <div class="leftpkname">
                   <span>{{item.nameCn}}</span>
                   <span>{{item.position}}</span>
                </div>
                <div class="userHeadr">
                  <img :src="item.customPic?item.customPic:'/static/scope/default_user.png'" alt="" srcset="">
                </div>
                <div class="numberId">
                  {{item.number}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="emitData">
         <div class="noDatas">
           <img src="/static/dataimg/no_data.png" alt="" srcset="">
           <span>暂无数据</span>
         </div>
      </div>
      <!-- <div style="height: 200px;"></div> -->

  </div>
</template>


<script>
  import {teamLineUp} from "@/api/scope.js"
  export default {
    props:{
      matchId:{
        type:String,
        default:'',
      },
      info: {
        // 声明类型
        type: Object,
        //声明是否必需
        require: true,
        // 声明默认值
        default: {}
      }
    },
    watch: {
      info: {
        handler(e) {
          console.log(e);
        },
        deep: true
      }
    },
    methods:{
      initData(){
        teamLineUp({
          matchId:this.info.matchId
        }).then(res=>{
          console.log('阵容数据',res);
          if(res.data.code == 200){
            let {homeNowMatchLineUp,awayNowMatchLineUp} =  res.data.data;
            this.homeNowMatchLineUp  = homeNowMatchLineUp;
            this.awayNowMatchLineUp = awayNowMatchLineUp;
          }
        })
      }
    },
    created() {
      console.log(this.info);
      this.initData()
    },
    data() {
      return {
        key: '',
        homeNowMatchLineUp:{},
        awayNowMatchLineUp:{}
      }
    },
  }
</script>

<style lang="scss">
  @import '../../assets/style/flex.scss';
  .emitData{
     .noDatas{
       width: 100%;
       display: flex;
       justify-content: center;
       padding:50px 0;
       flex-direction: column;
       align-items: center;
       span{
        margin-top: 20px;
        font-size: 14px;
        color: #999999;
       }
       img{
         width: 189px;
         height: 238px;
       }
     }
  }
  .firstPk{
    padding: 0 24px;
    .pkGroup{
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      .leftpklist{
        flex: 1;
        min-height:54px;
        display: flex;
        flex-direction: column;
        border-top: 1px solid rgba(0,0,0,.1);
        border-right: 1px solid rgba(0,0,0,.1);
      }
      .leftpkItem,.rightpkItem{
        flex: 1;
        height: 54px;
        padding: 12px 0;
        border-top: 1px solid rgba(0,0,0,.1);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        .numberId{
          font-size: 18px;
          font-family: Bebas-Regular, Bebas;
          font-weight: 400;
          color: #333333;
        }
        .leftpkname{
          display: flex;
          flex-direction: column;
          span:nth-child(1){
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          span:nth-child(2){
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
        }
        .userHeadr{
          width: 30px;
          height: 30px;
          margin-left: 12px;
          margin-right: 6px;
          img{
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
      }
      .rightpkItem{
        flex: 1;
        height: 54px;
        padding: 12px 0;
        border-right: none !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .pkGroup:last-child{
      border-bottom: 1px solid rgba(0,0,0,.1);
      margin-bottom: 24px;
    }
    .firstPkName{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
    }
  }
  .battle_box{
    display: flex;
    align-items: center;
    .qiuImg{
      width: 20px;
      margin: 0 12px;
      height: 20px;
      img{
        width: 20px;
        height: 20px;
      }
    }
    .lines{
      width: 325px;
      height: 4px;
      background: #F2F2F2;
      position: relative;
      .qius{
        position: absolute;
        left: 0;
        top: -2px;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        background: #F2F2F2;
      }
      .qiu{
        position: absolute;
        top: -2px;
        right: 0;
        width: 8px;
        border-radius: 50%;
        height: 8px;
        background: #F2F2F2;
      }
    }
  }
 .headertop {
   height: 90px;
   padding: 0 25px;
   box-sizing: border-box;

   .homeName {
     font-size: 18px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #333333;

     img {
       width: 35px;
       height: 35px;
       margin: 0 6px;
     }
   }

   .scoreNums {
     font-size: 30px;
     font-family: PingFangSC-Medium, PingFang SC;
     font-weight: 500;
     color: #333333;

     span {
       padding: 4px;
       width: 30px;
       height: 40px;
       background: #DADADA;
       border-radius: 2px;
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_battle.vue